import '../Shared/common.scss';
import { InputLabel, OutlinedInput, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";

const MoneyInput = ({
    control,
    label,
    name = "amount",
    symbol = "\u00A3", // Unicode £ symbol 
    size = "medium",
}: any & {
    control?: any;
    name?: string;
    label?: string;
    symbol?: string;
    size?: string;
}) => {

    return (
        <>
            <Controller
                key="amount-controller"
                name={name}
                control={control}
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                    formState,
                }) => (
                    <>
                        <InputLabel key="amount-label" htmlFor="amount">{label}</InputLabel>
                        <OutlinedInput
                            key="amount-input"
                            id="amount"
                            startAdornment={<InputAdornment position="start">{symbol}</InputAdornment>}
                            name={name}
                            label={label}
                            value={value}
                            type='number'
                            onChange={onChange}
                            inputProps={{
                                min: 0
                            }}
                            size={size}
                        />
                    </>

                )}
            />
        </>
    );
};

export default MoneyInput;
